// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"pagetitle-module--titleWrapper--3O_og","title":"pagetitle-module--title--3ro1_"};